<template>
  <div class="project-update-container">
    <div class="project-update-name">
      <h3>{{ project.name }}</h3>
    </div>
    <div class="tab-action">
      <router-link :to="{ name: 'projects.edit', params: {} }">
        <div :class="{ 'tab-active': tab === 1 }" class="tab-update">
          {{ $t("project_management.project_detail.catalog_name.project_detail") }}
        </div>
      </router-link>
      <router-link :to="{ name: 'projects.effort' }">
        <div :class="{ 'tab-active': tab === 2 }" class="tab-effort">
          {{ $t("project_management.project_detail.catalog_name.project_effort") }}
        </div>
      </router-link>
      <router-link :to="{ name: 'projects.review' }">
        <div :class="{ 'tab-active': tab === 3 }" class="tab-review">
          {{ $t("project_management.project_detail.catalog_name.project_overview") }}
        </div>
      </router-link>
      <router-link :to="{ name: 'projects.activities' }">
        <div :class="{ 'tab-active': tab === 4 }" class="tab-kickoff">
          {{ $t('fields.project.activities') }}
        </div>
      </router-link>
      <router-link v-if="project.project_type === 1" :to="{ name: 'ContractManagement' }">
        <div :class="{ 'tab-active': tab === 5 }">
          {{ $t("project_management.project_detail.catalog_name.contract_history") }}
        </div>
      </router-link>
    </div>
    <hr/>
    <slot></slot>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "ProjectDetailLayout",
  props: {
    tab: {
      type: Number,
    },
  },
  metaInfo() {
    let title = '';
    if (this.$route.meta.breadcrumb === 'projectEdit') {
      title = this.$t("bread_crumb.project.edit")
    } else if (this.$route.meta.breadcrumb === 'projectManagementEffort') {
      title = this.$t("bread_crumb.project.effort")
    } else if (this.$route.meta.breadcrumb === 'projectManagementReview') {
      title = this.$t("bread_crumb.project.review")
    } else if (this.$route.meta.breadcrumb === 'projectManagementActivities') {
      title = this.$t("bread_crumb.project.activities")
    } else if (this.$route.meta.breadcrumb === 'projectContract') {
      title = this.$t("bread_crumb.project.contract")
    }
    return {
      title: title,
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  computed: {
    ...mapGetters({
      project: "project/project",
    }),
  },
  created() {
    if (!this.project.id) {
      this.$store.dispatch("project/showDetail", this.$route.params.id)
    }
  }
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "Helvetica Neue";
  src: url('../../assets/font/helveticaneuemedium.ttf') format("truetype");
}

@font-face {
  font-family: "Roboto";
  src: url('../../assets/font/Roboto-Medium.ttf') format("truetype");
}

.project-update-container {
  margin: 30px;
  padding: 30px 0 15px 0;
  background: #ffffff;
  border: 1px solid #efefef;
  border-radius: 10px;
  font-family: Helvetica Neue;

  .project-update-name {
    h3 {
      text-align: center;
      margin-bottom: 30px;
      color: #1f2d3d;
      font-weight: 700;
      font-size: 20px;
    }
  }

  .tab-action {
    display: flex;
    background: #eeeeee;
    border-radius: 10px;
    margin: 0 30px;

    @media only screen and (max-width: 1300px) {
      flex-direction: column;
    }

    a {
      flex: 1 1 25%;
      color: #303c54;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        text-decoration: unset;
      }

      @media only screen and (max-width: 1300px) {
        &:last-child {
          flex: 1 1 31%;
        }
      }

      div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 14px 10px;
        border-radius: 10px;
        font-size: 16px;
        font-weight: 400;
        line-height: 19px;
      }

      div.tab-active {
        background: #ffffff;
        box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.14);
        color: #303c54;
        font-weight: 700;
        height: 88%;
        width: 100%;
      }
    }
  }

  hr {
    border: 1px solid #cfcfcf;
    margin-right: 30px;
    margin-left: 30px;
  }
}
</style>
